// TODO LUCAS DEPRECATE AND REPLACE
export function pathologyUrl(categorySlug, specialtySlug) {
  return `/pathologies/${categorySlug}/${specialtySlug}/`;
}

export function pathologyCategoryUrl(categorySlug) {
  return `/pathologies/${categorySlug}/`;
}